import React, {useState, useEffect, useContext} from 'react'
import {Grid, AppBar, Toolbar, Switch} from '@material-ui/core'
import Home from './Home'
import NavigationDrawer from './NavigationDrawer/NavigationDrawer'
import Dashboard from './Dashboard/Dashboard'
import {GlobalSetting} from '../../utils/constants'
import Navbar from './Navbar/Navbar'
import {useStickyState} from '../../utils/customHooks'
import {
    getMyAccountAPIData,
    getResourceDetails,
    getClientProgramAPIData,
} from '../services/myaccount'
import {getUniqueObjectArray} from '../../utils/utils'
import {useLocation, useHistory} from 'react-router-dom'
import queryString from 'query-string'
import {atom, useRecoilState} from 'recoil'
import Loader from '../../components/Loader'
// import {
//     tinNumbersRestrictionPrograms,
//     tabSchema,
//     dashboardCardSchema,
//     qualifiedConstantSchema,
//     enrolledConstantSchema,
//     programDropdownDetails,
//     myAccountSchema,
//     myAccountCapTechSurveySchema,
// } from '../utils/constants'

import {getProgramConfiguration} from '../../services/outReach'

export const MyAccountContext = React.createContext()

export const altlogoURLAtom = atom({
    key: 'altlogoURL',
    default: '',
})

export const logoURLAtom = atom({
    key: 'logoURL',
    default: '',
})

export const faviconURLAtom = atom({
    key: 'faviconUrl',
    default: '',
})

const MyAccountSetting = props => {
    const [showManageAccont, setShowManageAccont] = useState(false)
    const [accountEntity, setaccountEntity] = useState([])
    const [OrgSelectRefresh, setOrgSelectRefresh] = useState(false)
    const [PrgSelectRefresh, setPrgSelectRefresh] = useState(false)

    const [enrolledObject, setenrolledProgram] = useState({
        subscribedprogram: [],
    })
    const [qualifiedObject, setqualifiedProgram] = useState({
        availableprogram: [],
    })
    const [routeObject, setrouteObject] = useStickyState(
        {key: 'dashboard', actiontype: ''},
        'routeObject'
    )
    const [clientObject, setClientObject] = useStickyState(
        GlobalSetting.entityObject,
        'clientObject'
    )
    const [practiceObject, setPracticeObject] = useStickyState(
        {practiceId: '', practicename: '', subscribedid: ''},
        'practiceObject'
    )
    const [resourceObject, setResourceObject] = useState(
        {isPolicyBased: GlobalSetting.IS_POLICY_BASED, resource: []},
        'resourceObject'
    )

    const [clientProgramObject, setClientProgramObject] = useStickyState(
        {programs: []},
        'clientProgramObject'
    )
    const [clientProgramSelectedObject, setClientProgramSelectedObject] = useStickyState(
        '',
        'unit'
    )

    const [myAccountSchema, setMyAccountSchema] = useState({})

    const [altlogoURL, setAltlogoURL] = useRecoilState(altlogoURLAtom)
    const [logoURL, setlogoURL] = useRecoilState(logoURLAtom)
    const [faviconURL, setfaviconURL] = useRecoilState(faviconURLAtom)
    const [loading, setLoading] = useState(false)
    const [pageLoading, setPageLoading] = useState(false)

    useEffect(() => {
        const callApi = async () => {
            setPageLoading(true)
            const response = await getClientProgramAPIData(
                'myaccountinnerconfig',
                {},
                {route: 'onboard ', 'client-program-id': 19},
                {}
            )
            if (
                Object.keys(response.configuration && response.configuration).length > 0
            ) {
                let MASchema = response.configuration
                setMyAccountSchema({
                    is_hide_auth_type: MASchema.is_hide_auth_type,
                    dashboardCardSchema: MASchema.dashboardCardSchema,
                    qualifiedConstantSchema: MASchema.qualifiedConstantSchema,
                    enrolledConstantSchema: MASchema.enrolledConstantSchema,
                    programDropdownDetails: MASchema.programDropdownDetails,
                    tinNumbersRestrictionPrograms: MASchema.tinNumbersRestrictionPrograms,
                    tabSchema: MASchema.tabSchema,
                    myAccountSchema: MASchema.myAccountSchema,
                    myAccountCapTechSurveySchema: MASchema.myAccountCapTechSurveySchema,
                })
                setPrgSelectRefresh(true)
            } else setPageLoading(false)
        }
        callApi()
    }, [])

    useEffect(() => {
        if (clientProgramSelectedObject.length > 0) {
            setPageLoading(true)
            getAccountCliententity()
        }
    }, [clientProgramSelectedObject, OrgSelectRefresh])

    useEffect(() => {
        if (PrgSelectRefresh) {
            getAccountClientProgram()
            setPrgSelectRefresh(false)
        }
    }, [PrgSelectRefresh])

    const getAccountCliententity = () => {
        const callApi = async () => {
            const data = await getMyAccountAPIData(
                'cliententity/accountcliententity',
                {},
                {unit: clientProgramSelectedObject},
                {}
            )
            if (Object.entries(data).length > 0) {
                if (data.error && Object.keys(data.error).length > 0) {
                    setPageLoading(false)
                } else {
                    const filteredData = getUniqueObjectArray(data, 'cliententityid')
                    let activeObj = [{}]
                    setaccountEntity(filteredData)
                    if (clientObject.practiceid !== 0) {
                        activeObj = filteredData.filter(c => {
                            return c.practiceid === clientObject.practiceid
                        })
                    }
                    setClientObject({
                        ...clientObject,
                        practiceid:
                            (activeObj[0] && activeObj[0].practiceid) ||
                            filteredData[0].practiceid ||
                            '',
                        cliententityid:
                            (activeObj[0] && activeObj[0].cliententityid) ||
                            filteredData[0].cliententityid ||
                            0,
                        parentcliententityid:
                            (activeObj[0] && activeObj[0].parentcliententityid) ||
                            filteredData[0].parentcliententityid ||
                            0,
                        cliententityname:
                            (activeObj[0] && activeObj[0].cliententityname) ||
                            filteredData[0].cliententityname ||
                            '',
                        entitytypeid:
                            (activeObj[0] && activeObj[0].entitytypeid) ||
                            filteredData[0].entitytypeid ||
                            0,
                        entitytype:
                            (activeObj[0] && activeObj[0].entitytype) ||
                            filteredData[0].entitytype ||
                            '',
                    })
                    setPageLoading(false)
                }
            }
        }
        callApi()
    }

    const getAccountClientProgram = () => {
        const callApi = async () => {
            const data = await getMyAccountAPIData(
                'subscribedprogram',
                {},
                {
                    'client-entity-id': clientObject?.practiceid,
                }
            )
            const defaultProgram = [
                {
                    clientprogramid: 0,
                    progamname: 'ALL',
                    enrollmentcomplete: true,
                    acronym: 'all',
                },
            ]

            const mergeProgram =
                data && data.length === 1 ? data : defaultProgram.concat(data)

            let programDropDownData = []
            mergeProgram.forEach(element => {
                let myprogram = {
                    value: element.clientprogramid,
                    label: element.progamname,
                    acronym: element.acronym,
                }
                programDropDownData.push({
                    value: element.clientprogramid,
                    label: element.progamname,
                    obj: {...myprogram},
                })
            })

            let selectedProgramObj = {
                value:
                    data && data.length === 1
                        ? data[0].clientprogramid
                        : data &&
                          data.length > 1 &&
                          clientProgramSelectedObject.length === 0
                        ? data[0].clientprogramid
                        : 0,

                label:
                    data && data.length === 1
                        ? data[0].progamname
                        : data &&
                          data.length > 1 &&
                          clientProgramSelectedObject.length === 0
                        ? data[0].progamname
                        : 'ALL',

                acronym:
                    data && data.length === 1
                        ? data[0].acronym
                        : data &&
                          data.length > 1 &&
                          clientProgramSelectedObject.length === 0
                        ? data[0].acronym
                        : 'all',
            }

            let selectedProgramDefault = {
                value:
                    data && data.length === 1
                        ? data[0].clientprogramid
                        : data &&
                          data.length > 1 &&
                          clientProgramSelectedObject.length === 0
                        ? data[0].clientprogramid
                        : 0,

                label:
                    data && data.length === 1
                        ? data[0].progamname
                        : data &&
                          data.length > 1 &&
                          clientProgramSelectedObject.length === 0
                        ? data[0].progamname
                        : 'ALL',

                acronym:
                    data && data.length === 1
                        ? data[0].acronym
                        : data &&
                          data.length > 1 &&
                          clientProgramSelectedObject.length === 0
                        ? data[0].acronym
                        : 'all',
                obj: {...selectedProgramObj},
            }

            clientProgramSelectedObject && clientProgramSelectedObject.length > 0
                ? setClientProgramSelectedObject(clientProgramSelectedObject)
                : setClientProgramSelectedObject(selectedProgramDefault.acronym)

            setClientProgramObject({
                programs: programDropDownData,
            })
            getResource()
        }
        callApi()
    }

    useEffect(() => {
        const callApi = async () => {
            const data = await getMyAccountAPIData(
                'cliententity/programassociationdetails',
                {},
                {
                    'client-entity-id': clientObject.cliententityid,
                }
            )
            console.log(
                '🚀 ~ file: Layout.js:315 ~ callApi ~ data.altlogoUrl',
                data.altlogoUrl
            )
            if (data.altlogoUrl) setAltlogoURL(data.altlogoUrl)
            //if (!data.ismultiprogramassociated) {
            setlogoURL(data.logo)
            setfaviconURL(data.favicon)
            // }
        }
        if (clientObject.cliententityid) callApi()
    }, [clientObject] && [clientObject['cliententityid']])

    const getResource = () => {
        const callApi = async () => {
            let data = await getResourceDetails(
                'resourcedetails',
                {
                    ismenu: 'false',
                    resourcename: 'MyAccount Application',
                },
                {
                    'Content-Type': 'application/json',
                }
            )
            let resource = []
            if (
                data &&
                data.success &&
                data.success.resourcedetails &&
                data.success.resourcedetails.length > 0
            ) {
                data.success.resourcedetails.map(res => {
                    if (res.resource === 'MyAccount Application') resource = res
                })
            }
            setResourceObject({
                isPolicyBased: true,
                resource: resource,
            })
            setPageLoading(false)
        }
        if (GlobalSetting.IS_POLICY_BASED) callApi()
        else {
            setPageLoading(false)
            setResourceObject({
                isPolicyBased: false,
                resource: [],
            })
        }
    }

    const toggleManageAccount = () => {
        setShowManageAccont(!showManageAccont)
    }

    if (loading || clientProgramSelectedObject.length === 0) {
        return (
            <div
                style={{
                    marginLeft: '48%',
                    marginTop: '25%',
                }}
            >
                <Loader />
            </div>
        )
    }

    return (
        <MyAccountContext.Provider
            value={{
                toggleManageAccount,
                showManageAccont,
                routeObject,
                setrouteObject,
                clientObject,
                setClientObject,
                resourceObject,
                practiceObject,
                setPracticeObject,
                setResourceObject,
                accountEntity,
                OrgSelectRefresh,
                setOrgSelectRefresh,
                PrgSelectRefresh,
                setPrgSelectRefresh,
                enrolledObject,
                setenrolledProgram,
                qualifiedObject,
                setqualifiedProgram,
                clientProgramObject,
                setClientProgramObject,
                clientProgramSelectedObject,
                setClientProgramSelectedObject,
                myAccountSchema,
            }}
        >
            {pageLoading && <Loader type="center-overlay" />}
            {Object.keys(myAccountSchema).length > 0 && props.children}
        </MyAccountContext.Provider>
    )
}

const HeaderRenderer = props => {
    const {routeObject, setrouteObject} = useContext(MyAccountContext)
    const setRouter = routeinfo => setrouteObject({...routeObject, key: routeinfo})
    const keyChange = () => {
        switch (routeObject.key) {
            case 'available':
                return 'qualified'
            case 'subscribed':
                return 'enrolled'
            case 'addedituser':
                return 'user'
            default:
                return routeObject.key
        }
    }

    switch (props.routeinfo) {
        case 'dashboard':
            // case 'subscribed':
            // case 'available':
            return (
                <AppBar position="fixed" className="page-header">
                    <Toolbar className="page-header__toolbar">
                        <Navbar />
                    </Toolbar>
                </AppBar>
            )
        default:
            return <NavigationDrawer setRouter={setRouter} activeRoute={keyChange()} />
    }
}

const BodyRenderer = props => {
    switch (props.routeinfo) {
        case 'dashboard':
            return <Dashboard />
        default:
            return <Home />
    }
}

const Layout = props => {
    // const {routeObject, setrouteObject} = useSettings()
    const {routeObject, setrouteObject} = useContext(MyAccountContext)
    // let history = useHistory()
    useEffect(() => {
        document.title = 'My Account'
    }, [])

    return (
        <Grid item xs className="page-header__wrapper myacc-page__wrapper">
            <HeaderRenderer routeinfo={routeObject.key} />
            <main className="fi-container--full-height">
                <Grid item className="fi-stack--desktop--toolbar"></Grid>
                <Grid container className="myacc--page__wrapper">
                    <Grid item xs className="myacc--page-content__wrapper">
                        <BodyRenderer routeinfo={routeObject.key} />
                    </Grid>
                </Grid>
            </main>
        </Grid>
    )
}
const LayoutExport = p => {
    const [loading, setLoading] = useState(true)
    let location = useLocation()
    let history = useHistory()

    useEffect(() => {
        const params = queryString.parse(location.search)
        if (params['isredirect']) {
            window.sessionStorage.clear()
            history.replace(location.pathname)
        }
        setLoading(false)
    }, [])

    if (loading) {
        return null
    }

    return (
        <MyAccountSetting>
            <Layout />
        </MyAccountSetting>
    )
}
export default LayoutExport
